import { groq } from '#imports';

export function getQuery({ searchQuery, themeId }) {
  const query = groq`*[_type == "article" && theme._ref != null && theme._ref == "${themeId}" && !(_id in path('drafts.**'))]
    | score(title match "${searchQuery}" || pt::text(content) match "${searchQuery}")
    | order(_score desc) [0...${100}] {
      _score,
      _id,
      _type,
      slug,
      image,
      title,
      subtitle,
      publishedAt,
      isArticleExternalSourceType,
      externalSource,
      crew[]{staff->, speciality->},
    }
    [_score > 0]
  `;
  return { query, params: { searchQuery } };
}
